import { IAuthState, IUserType } from "../types/dashboardTypes"
import { consts } from "../../../common/consts";
import { addMonths, addYears, endOfMonth, endOfYear, startOfMonth, startOfYear } from 'date-fns';
import round from 'lodash/round';


const getRoles = (authStore: IAuthState): IUserType => {
    const roles: IUserType = {
        IsAdmin: authStore?.data?.IsAdmin || false,
        SMADriver: authStore?.data ? authStore?.data?.role?.indexOf(consts.Permissions.SMADriver) >= 0 ? true : false : false,
        CanViewDashboard: authStore?.data?.role?.split(',')?.some(p => p === consts.Permissions.ViewDashboard) ?? false,
        CanViewDashboardAsSMA: authStore?.data?.role?.split(',')?.some(p => p === consts.Permissions.SMAAdminPatientTransportDashboard) ?? false,
        CanViewSchedule: authStore?.data?.role?.split(',')?.some(p => p === consts.Permissions.ViewSchedule || p === consts.Permissions.SMAViewSchedule) ?? false,
        IsCustomer:authStore.data?.IsCustomer||false,
    }
    return roles;
}

const DATE_MAP: any = {
    "last30days": [new Date().setDate(new Date().getDate() - 29), new Date()],
    "thismonth": [startOfMonth(new Date), endOfMonth(new Date())],
    "thisyear": [startOfYear(new Date), endOfYear(new Date())],
    "lastmonth": [startOfMonth(addMonths(new Date(), -1)), endOfMonth(addMonths(new Date(), -1))],
    "lastyear": [startOfYear(addYears(new Date(), -1)), endOfYear(addYears(new Date(), -1))],
}

const hubMessageHandler = (startDate: any, endDate: any, selectedLocations: any[], refreshCharts: any) => {
    const reqData = {
        "locationId": selectedLocations,
        "scheduleStartDate": startDate,
        "scheduleEndDate": endDate
    };
    refreshCharts(reqData);
}

const calcGridYValues = (maxVal: number): number[] => {
    if (maxVal === 0) {
        return [0];
    }
    const middleValue = Math.round(maxVal / 2);
    const isMiddleValueUnique = middleValue !== 0 && middleValue !== maxVal;
    return isMiddleValueUnique ? [0, middleValue, maxVal] : [0, maxVal];
}

const isSMAUser = (userRoles: any) => userRoles.CanViewDashboardAsSMA || userRoles.IsAdmin;

const getAlertColor = (userRoles: any,
    currentValue: number,
    redAlert: number | null,
    yellowAlert: number | null,
    isItAbove: boolean = false): string => {
    if (!isSMAUser(userRoles))
        return "#fff";

    if (!isItAbove && redAlert !== null && currentValue < redAlert) {
        return "#E05151";
    }

    if (!isItAbove && yellowAlert !== null && currentValue < yellowAlert) {
        return "#F4B827";
    }

    if (isItAbove && redAlert !== null && currentValue > redAlert) {
        return "#E05151";
    }

    if (isItAbove && yellowAlert !== null && currentValue > yellowAlert) {
        return "#F4B827";
    }

    return "#fff";
}

const getAlertOpacity = (userRoles: any,
    currentValue: number,
    redAlert: number | null,
    yellowAlert: number | null,
    isItAbove: boolean = false): string => {
    if (!isSMAUser(userRoles))
        return "50%";

    if (!isItAbove &&
        ((redAlert !== null && currentValue < redAlert) ||
            (yellowAlert !== null && currentValue < yellowAlert))) {
        return "100%";
    }

    if (isItAbove &&
        ((redAlert !== null && currentValue > redAlert) ||
            (yellowAlert !== null && currentValue > yellowAlert))) {
        return "100%";
    }

    return "50%";
}

const getAlertLabelDisplay = (currentValue: number,
    redAlert: number | null,
    yellowAlert: number | null,
    isItAbove: boolean = false) => {
    if (!isItAbove &&
        ((redAlert !== null && currentValue < redAlert) ||
            (yellowAlert !== null && currentValue < yellowAlert))
    )
        return "block";

    if (isItAbove &&
        ((redAlert !== null && currentValue > redAlert) ||
            (yellowAlert !== null && currentValue > yellowAlert))
    )
        return "block";

    return "none";
}

const getAlertValue = (currentValue: number,
    redAlert: number | null,
    yellowAlert: number | null,
    isItAbove: boolean = false) => {
    
    const yellowAlertRounded = round(yellowAlert??0, 1);
    const redAlertRounded = round(redAlert??0, 1);
        
    if (isItAbove) {
        return (redAlert !== null && currentValue > redAlert ? redAlertRounded :
            yellowAlertRounded);
    } else {
        return (redAlert !== null && currentValue < redAlert ? redAlertRounded :
            yellowAlertRounded);
    }
}

export {
    getRoles,
    DATE_MAP,
    hubMessageHandler,
    calcGridYValues,
    isSMAUser,
    getAlertColor,
    getAlertOpacity,
    getAlertLabelDisplay,
    getAlertValue
}